import { OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { filter, tap } from 'rxjs/operators';

export abstract class AbstractEntityEditionComponent<T> implements OnInit {

  public entity: T;
  public isCreation: boolean;

  protected constructor(
    protected route: ActivatedRoute,
    protected instance: T
  ) {}

  public ngOnInit(): void {
    this.entity = this.instance;
    this.route.parent.data
      .pipe(
        tap(data => this.isCreation = data.entity === undefined),
        filter(data => data.entity !== undefined)
      )
      .subscribe(data => this.entity = data.entity);
  }
}
